import { setActiveDate, getBookContext, loadContext, invalidateBookContext } from './http';
import { getShiftDate } from './shiftDate';


function normalizeDateInput(dateInput) {
  if (dateInput instanceof Date) {
    const d = dateInput;
    const two = (n) => (n < 10 ? `0${n}` : String(n));
    return `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}`;
  }
  if (typeof dateInput === 'string') {
    return dateInput.trim();
  }
  throw new Error('Дата должна быть строкой YYYY-MM-DD или объектом Date');
}

export async function checkOrCreateBookByDate(dateInput) {
  const dateISO = normalizeDateInput(dateInput);
  const re = /^\d{4}-\d{2}-\d{2}$/;
  if (!re.test(dateISO)) {
    throw new Error(`Некорректный формат даты: "${dateISO}". Ожидается YYYY-MM-DD.`);
  }
  setActiveDate(dateISO);

  return loadContext('book', dateISO);
}

export async function resolveBookIdForDate(dateInput) {
  const book = await checkOrCreateBookByDate(dateInput);
  if (typeof book === 'number') return book;
  if (book?.id) return book.id;
  if (book?.book?.id) return book.book.id;
  return undefined;
}

export function setBookActiveDate(date) {
  setActiveDate(date);
}

// По ТЗ «Рабочие задачи» блок 5: армейская смена 20:00→20:00. Книга ведётся
// по дате текущей смены (после 20:00 — уже завтрашняя).
export function computeBookDate(base = new Date()) {
  return getShiftDate((base instanceof Date) ? base : new Date());
}

export async function ensureTodayBookContext() {
  const dateISO = computeBookDate();
  setActiveDate(dateISO);
  return checkOrCreateBookByDate(dateISO);
}

export function refreshTodayBookContext() {
  const dateISO = computeBookDate();
  invalidateBookContext(dateISO);
}
